import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mobile-bottom-nav" }
const _hoisted_2 = { class: "mobile-bottom-nav__item mobile-bottom-nav__item--active" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-house-chimney" }, null, -1)
const _hoisted_4 = { class: "mobile-bottom-nav__item" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-product-hunt" }, null, -1)
const _hoisted_6 = { class: "mobile-bottom-nav__item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cart-plus" }, null, -1)
const _hoisted_8 = { class: "mobile-bottom-nav__item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-heart" }, null, -1)
const _hoisted_10 = { class: "mobile-bottom-nav__item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user" }, null, -1)

import commons from "@/utils/Common";
import { watch, reactive, ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'MenuBottom',
  setup(__props) {

const router = useRouter();
const homePage = () => {
  router.push({ path: "./" })
}

const homeWheel = () => {
  router.push({ path: "/roulette" })
}

const homeGift = () => {
  router.push({ path: "/gift" })
}

const cart = () => {
  router.push({ path: "/cart" })
}

const homeProduct = () => {
  router.push({ path: "/products" })
}

const homeUser = () => {
  router.push({ path: "/inform" })
}

const favourite = () => {
  router.push({ path: "/favourite" })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "mobile-bottom-nav__item-content",
          onClick: homePage
        }, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('menu.home')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "mobile-bottom-nav__item-content",
          onClick: homeProduct
        }, [
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('menu.products')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "mobile-bottom-nav__item-content",
          onClick: cart
        }, [
          _hoisted_7,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('menu.cart')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: "mobile-bottom-nav__item-content",
          onClick: favourite
        }, [
          _hoisted_9,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('text.favourite')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", {
          class: "mobile-bottom-nav__item-content",
          onClick: homeUser
        }, [
          _hoisted_11,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('menu.user')), 1)
        ])
      ])
    ])
  ]))
}
}

})